import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { get, isEmpty } from 'lodash';
import { epgSelectors } from 'store/epg';
import { useLoadChannels } from 'hooks/data';
import EPGWidget from './EPGWidget';

const parseChannelId = (pathname = '') => Number(get(pathname.match(/channel\/(\d+)/), [1]));

const EPGWidgetContainer = () => {
  const { location } = useHistory();
  const channelId = useMemo(() => parseChannelId(location.pathname), [location]);
  const isVisible = useSelector(epgSelectors.selectIsVisible);
  const { data: channels } = useLoadChannels({ all: true });

  if (!isVisible || isEmpty(channels)) return null;

  return <EPGWidget channels={channels} playingChannelId={channelId} />;
};

export default EPGWidgetContainer;
